import React from 'react';
import ToolPageLayout from '../tools/ToolPageLayout';
import BudgetPlanner from './BudgetPlanner';
import './BudgetPlanner.css';

const BudgetPlannerPage = () => {

  return (
    <ToolPageLayout
      pageTitle={'Юнит-экономика на минималках'}
      title={
        <>
          {'Юнит-экономика'}
          <em>{'на минималках'}</em>
          <br />
          {'бюджета'}
        </>
      }
      lead={'Введите показатели своего бизнеса — калькулятор посчитает прибыль на продажу, допустимый CPL и план на следующий месяц.'}
      headerTag={'Юнит-экономика'}
      wide
      showEyebrow={false}
    >
      <BudgetPlanner />
    </ToolPageLayout>
  );
};

export default BudgetPlannerPage;
